// src/components/img/GalerySectionVessels/Emma.tsx
import React from "react";
import vesselImage from "./emma.jpeg";

const VesselEmma: React.FC = () => <img src={vesselImage} alt="Vessel Emma" />;

export default VesselEmma;
